import { render, staticRenderFns } from "./WorksIntro.vue?vue&type=template&id=f5bdf202&scoped=true&"
import script from "./WorksIntro.vue?vue&type=script&lang=js&"
export * from "./WorksIntro.vue?vue&type=script&lang=js&"
import style0 from "./WorksIntro.vue?vue&type=style&index=0&id=f5bdf202&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5bdf202",
  null
  
)

export default component.exports